import { useRouteResources } from '@lp/features/RoutePlanner/hooks/useRouteResources';
import { getResourceEmployeeData, getResourceOscDeviceData } from '@lp/features/RoutePlanner/utils';
import { useCountriesData } from '@/contexts/CountriesDataProvider';
import { EmployeeComposed, EmployeeRole } from '@/api/apis/resources';

export const useLegFormResource = () => {
  const { ClinicalSpecialist: specialists, OCSConsole: devices, Surgeon: surgeons } = useRouteResources();
  const { resolveSubdivisionName } = useCountriesData();

  const specialistsData = specialists.length
    ? specialists.map((r) => {
        return getResourceEmployeeData({
          defaultTitle: 'Clinical Specialist',
          resource: r,
          resourceData: r?.data,
          type: EmployeeRole.ClinicalSpecialist,
          resolveSubdivisionName,
        });
      })
    : [
        getResourceEmployeeData({
          defaultTitle: 'Clinical Specialist',
          type: EmployeeRole.ClinicalSpecialist,
        }),
      ];

  const surgeonsData = surgeons.length
    ? surgeons.map((r) => {
        return getResourceEmployeeData({
          defaultTitle: 'Surgeon',
          resource: r,
          resourceData: r?.data,
          type:
            r?.data &&
            (r?.data as EmployeeComposed).isContractor &&
            r?.resourceData?.roles &&
            r?.resourceData?.roles.includes(EmployeeRole.ContractorRetrievalSurgeon)
              ? EmployeeRole.ContractorRetrievalSurgeon
              : EmployeeRole.RetrievalSurgeon,
          resolveSubdivisionName,
        });
      })
    : [
        getResourceEmployeeData({
          defaultTitle: 'Surgeon',
          type: EmployeeRole.RetrievalSurgeon,
        }),
      ];

  const devicesData = devices.length
    ? devices.map((r) => {
        return getResourceOscDeviceData({
          defaultTitle: 'OCS Device',
          resource: r,
          resourceData: r?.data,
        });
      })
    : [
        getResourceOscDeviceData({
          defaultTitle: 'OCS Device',
        }),
      ];

  return {
    specialistsData,
    surgeonsData,
    devicesData,
  };
};
